module.exports = __webpack_public_path__ + "X Logo 2.d3f5212.png";